export default function (context) {
  if (!context.$auth.loggedIn) context.redirect('/auth/login')

  if (!context.store.getters['user/isProvider'])
    context.redirect('/legal-center/request-access')
}
